import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';


const useStyles = makeStyles(theme => ({
    button: {
        margin: theme.spacing(1),
        fontSize: '1.2rem',
        color: window.customColor ? window.customColor : '#95c41f'
    },
    input: {
        display: 'none',
    },
}));

export default function SearchButton(props) {
    const classes = useStyles();

    return (
        <label htmlFor="outlined-button-file">
            <Button variant="outlined" component="span" className={classes.button} onClick={props.onClick}>
                <Icon className={classes.icon} style={{color: window.customColor ? window.customColor : '#95c41f'}}>
                    search
                </Icon>
                {props.content}
            </Button>
        </label>
    );
}
